import axios, { AxiosInstance } from 'axios';
import log from '../services/LogService';
import { Matching } from '../interfaces/ProductService.interface';

interface MatchData {
  measurement_id: string;
  session_id: string;
  article_number: string;
}

class MatchingService {
  private params: MatchData;

  private client: AxiosInstance;

  constructor() {

    this.params = {
      measurement_id: '',
      session_id: '',
      article_number: '',
    };

    this.client = axios.create({
      baseURL: process.env.API_URL,
    });

  }

  setSessionId(sessionId: string) {
    this.params.session_id = sessionId;
    this.client.defaults.headers.common.Authorization = `Bearer ${sessionId}`;
  }

  setMeasurementId(measurementId: string) {
    this.params.measurement_id = measurementId;
  }

  setArticleNumber(artNum: string) {
    this.params.article_number = artNum;
  }

  createMatching(): Promise<Matching> {
    log.info('create Matching called', this.params);
    return this.client.post('/matchings', this.params)
      .then(result => {
        const matching:Matching = result.data;

        if (!matching.size || !matching.sizes || matching.sizes.length ===0){
          return matching;
        }

        const { size } = matching;

        const foundSize = matching.sizes.find(
          item => item.value === size.value);

        if (!foundSize) {
          return  matching;
        }

        matching.size.description = foundSize.description;

        return matching;

      });
  }
}

export default new MatchingService();
